<template>
  <v-layout style="background-color: #fff" class="mr-3">
      <v-card>
        <v-list three-line  color="#f2f2f2" class="overflow-y-auto px-5" style="max-height: 90vh; min-height: 90vh">
          <template v-if="getPoints.length == 0">
            <div 
              class="font-weight-medium title black--text pa-5" 
              style="text-align: center; font-size: 19px; font-weight: 600;">
              Ingresa una dirección o presiona  
              <br>
              <v-btn
                @click="geolocation"
                large
                class="px-0 my-2"
                color="#009640"
                style="min-width: min-content !important;"
              >
                <v-img :width="55" :height="45" contain src="../assets/icons/location.svg"></v-img>
              </v-btn>
              <br>
              para geo localizarte
            </div>
          </template>
          <template v-else>
            <CardPoint 
              v-for="(item, index) in getPoints"
              :id="`card-${index}`"
              v-bind:key="index" 
              :point="item"
              :index="index" 
              v-on:onSelectMode="selectMode"
              v-on:onPrint="print"
              class="mt-4"/>
          </template>
        </v-list>
      </v-card>
  </v-layout>
</template>

<script>
import CardPoint from './CardPoint';
import { mapGetters } from 'vuex';

  export default {
    name: "ListPoints",
    /* Componente encargado de generar la lista de tarjetas de puntos de atención */
    components: {
      CardPoint
    },
    data () {
      return {
      }
    }, 
    computed: {
      ...mapGetters(['getPoints']),
    },
    methods:{
      geolocation() {
        this.$emit('onGeolocation');
      },
      selectMode(mode){
        this.$emit("onSelectMode", mode);
      },
      print(){
        this.$emit("onPrint");
      }
    }
  }
</script>